import "./wire-management-state-controller.scss";

const WireManagementStateController = ({ visibleItems, setVisibleItems, items, totalItems: propTotalItems }) => {
  const addItemsCount = 10;
  const totalItems = propTotalItems !== undefined ? propTotalItems : items.length;
  const newVisibleItems =
    totalItems - visibleItems < addItemsCount
      ? totalItems - visibleItems
      : addItemsCount;

  const handleShowMore = () => {
    setVisibleItems(visibleItems + newVisibleItems);
  };

  const handleShowAll = () => {
    setVisibleItems(totalItems);
  };

  const startItem = 1;
  const endItem = Math.min(visibleItems, totalItems);

  return (
    <>
      <div className="pagination-wrapper">
        <span>
          {startItem}-{endItem} of {totalItems}
        </span>
        {visibleItems < totalItems && (
          <>
            <hr className="vertical-hr" />
            <span onClick={handleShowMore}>
              Show {newVisibleItems} more
            </span>
          </>
        )}
        {visibleItems < totalItems && (
          <>
            <hr className="vertical-hr" />
            <span onClick={handleShowAll}>Show all</span>
          </>
        )}
      </div>
    </>
  );
};

export default WireManagementStateController;
